// `tab` query param value that opens the operation photos section of /ride-verification
export const OPERATION_TAB = 'operation';
